// This file is automatically generated. Do not edit manually.

import { t } from "i18next";

export const ProductChangeStateValues = ["INITIAL", "IN_IMPLEMENTATION", "DONE", "CANCELLED"] as const;

export type ProductChangeState = (typeof ProductChangeStateValues)[number];

export const getProductChangeStateLabels = () => ({
	INITIAL: t("initial"),
	IN_IMPLEMENTATION: t("in_implementation"),
	DONE: t("done"),
	CANCELLED: t("cancelled"),
});

export const getProductChangeStateLabel = (value: ProductChangeState): string => {
	return getProductChangeStateLabels()[value];
};
